import { createContext, useEffect, useState } from "react";
import noop from "../functions/noop";

const HeaderContext = createContext();

export function HeaderContextProvider({ children, stickUntil = 100 }) {
  const [, setScrollY] = useState(0);
  const [hasScrolledFromTop, setHasScrolledFromTop] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isPulsing, setIsPulsing] = useState(false);

  const showHeader = () => setIsHidden(false);
  const pulseCart = () => setIsPulsing(true);

  useEffect(() => {
    if (!isPulsing) return noop;

    setTimeout(() => {
      setIsPulsing(false);
    }, 600);
  }, [isPulsing]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < stickUntil) {
        setHasScrolledFromTop(false);
        setIsHidden(false);
        return;
      }

      setHasScrolledFromTop(true);

      if (currentScrollY % 4 !== 0) return;

      setScrollY((lastValue) => {
        if (lastValue > currentScrollY) {
          setIsHidden(false);
          return currentScrollY
        }
        setIsHidden(true);
        return currentScrollY
      })
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [stickUntil]);


  return <HeaderContext.Provider value={{ showHeader, hasScrolledFromTop, isHidden, isPulsing, pulseCart }}>
    {children}
  </HeaderContext.Provider>

}

export default HeaderContext

